import { api } from "@/api"

export const sendMerchantGroupUserLoginLink = async (
  userId: string
) =>
  await api.post(
    `/merchant-group/users/${userId}/send-login-link/`,
    { isMerchantGroup: true }
  )
